import { Controller } from "@hotwired/stimulus"

// 記事の目次。デスクトップ(md以上)は展開、モバイルは折りたたむ。
// JS が無い場合は HTML の open 属性で展開のまま (no-JS / クローラ向けフォールバック)。
export default class extends Controller {
  connect() {
    this.mq = window.matchMedia("(min-width: 768px)")
    this.apply = this.apply.bind(this)
    this.apply()
    this.mq.addEventListener("change", this.apply)
  }

  disconnect() {
    this.mq.removeEventListener("change", this.apply)
  }

  apply() {
    this.element.open = this.mq.matches
  }
}
